






















import Vue from 'vue'
import { Profile2ElInterface } from '@/config/interfaces'
import DefaultProfilePic from '@/assets/profil.png'
import { LOGGED_IN_USER } from '@/store'
export default Vue.extend({
  name: 'Profile2El',

  props: {
    templateItemData: {
      type: Object as () => Profile2ElInterface,
      required: true
    }
  },
  data: function () {
    return {
      defaultProfilePic: DefaultProfilePic
    }
  },
  mounted: function () {
    let currentAvatar = this.$store.getters.getCurrentUserAvatar
    const imageUri = `${this.templateItemData.image.imageUri}`
    if (imageUri !== '' && imageUri !== 'null' && imageUri !== this.defaultProfilePic) {
      this.$store.dispatch('commitCurrentUserAvatar', imageUri)
      currentAvatar = imageUri
    }
    const userData = JSON.parse(localStorage.getItem(LOGGED_IN_USER) as string)
    if (userData !== null) {
      if (userData.avatar !== currentAvatar && currentAvatar !== this.defaultProfilePic) {
        userData.avatar = currentAvatar
        localStorage.setItem(LOGGED_IN_USER, JSON.stringify(userData))
      }
    }
  }
})
